(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["newsletter-signup"] && !Shopify.designMode) return;
  try {
    (() => {
        const selector = '[data-newsletter-form="WA5W8B"], [data-newsletter-form="TsFYFL"]';
        const key = 'cp:newsletter:WA5W8B:v1';
        const interval = 60000;
        const memory = { attempts: [], acceptedUntil: 0 };
        const read = () => {
            try {
                const saved = JSON.parse(sessionStorage.getItem(key));
                if (saved && Array.isArray(saved.attempts) && Number.isFinite(saved.acceptedUntil)) return saved;
            } catch {}
            return memory;
        };
        const save = (state) => {
            memory.attempts = state.attempts;
            memory.acceptedUntil = state.acceptedUntil;
            try { sessionStorage.setItem(key, JSON.stringify(state)); } catch {}
        };
        const setup = (root) => {
            if (root.dataset.newsletterReady) return;
            root.dataset.newsletterReady = 'true';
            const widget = root.querySelector('[data-newsletter-widget]');
            const status = root.querySelector('[data-newsletter-status]');
            const trap = root.querySelector('[data-newsletter-trap]');
            const recovery = root.querySelector('[data-newsletter-recovery]');
            let lastAttempt = 0;
            let accepted = false;
            let pendingTimer;
            const revealRecovery = () => {
                if (root.isConnected && !accepted) recovery.hidden = false;
            };
            const mountTimer = setTimeout(() => {
                if (!widget.querySelector('input[type="email"]')) revealRecovery();
            }, 20000);
            const feedback = (success) => {
                status.textContent = success ? root.dataset.newsletterSuccess : root.dataset.newsletterError;
                status.hidden = false;
                if (success) {
                    accepted = true;
                    clearTimeout(pendingTimer);
                    clearTimeout(mountTimer);
                    recovery.hidden = true;
                    widget.hidden = true;
                }
            };
            const guard = (event) => {
                if (event.type === 'click') {
                    const button = event.target.closest('button');
                    if (!button || !widget.contains(button) || !widget.querySelector('input[type="email"]')) return;
                } else if (event.type === 'keydown') {
                    if (event.key !== 'Enter' || event.target.type !== 'email' || !widget.contains(event.target)) return;
                } else if (!widget.contains(event.target)) return;
                const emailInput = widget.querySelector('input[type="email"]');
                if (emailInput && !emailInput.validity.valid) return;
                const now = Date.now();
                const state = read();
                state.attempts = state.attempts.filter(time => Number.isFinite(time) && time > now - interval);
                if (trap.value || state.acceptedUntil > now || (now - lastAttempt > 250 && state.attempts.length >= 3)) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    feedback(Boolean(trap.value || state.acceptedUntil > now));
                    return;
                }
                if (now - lastAttempt > 250) {
                    state.attempts.push(now);
                    save(state);
                    lastAttempt = now;
                    clearTimeout(pendingTimer);
                    pendingTimer = setTimeout(revealRecovery, 20000);
                }
            };
            root.addEventListener('click', guard, true);
            root.addEventListener('submit', guard, true);
            root.addEventListener('keydown', guard, true);
            if (read().acceptedUntil > Date.now()) feedback(true);
            window.addEventListener('klaviyoForms', (event) => {
                if (event.detail?.formId !== root.dataset.newsletterForm || event.detail.type !== 'submit' || !root.isConnected) return;
                const state = read();
                state.acceptedUntil = Date.now() + interval;
                save(state);
                feedback(true);
            });
        };
        const initialize = () => document.querySelectorAll(selector).forEach(setup);
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
        else initialize();
        document.addEventListener('shopify:section:load', initialize);
    })();
  } catch(e) { console.error(e); }
})();

})();
